module.exports = __webpack_public_path__ + "img/django.a0ebccaa.svg";